(function () {
    'use strict';

    angular.module("imApp").factory("travelWageSetMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 1495,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
